export default __webpack_public_path__ + "static/media/sticker-t.bee2aeac.png";